var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Tab, Menu, styled } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import clsx from 'clsx';
import { HorizontalSubMenuContext } from './HorizontalSubMenuContext';
import { useAppLocationMatcher } from '../app-location';
export var SubMenu = function (_a) {
    var value = _a.value, TabProps = _a.TabProps, MenuProps = _a.MenuProps, className = _a.className, children = _a.children, props = __rest(_a, ["value", "TabProps", "MenuProps", "className", "children"]);
    var match = useAppLocationMatcher();
    var _b = useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (_jsxs(Root, { children: [_jsx(StyledTab, __assign({ className: clsx(className, open ? SubMenuClasses.open : SubMenuClasses.notOpen, match(value) && SubMenuClasses.selected), value: value, onClick: handleClick, icon: open ? _jsx(KeyboardArrowUpIcon, {}) : _jsx(KeyboardArrowDownIcon, {}), iconPosition: "end" }, TabProps, props)), _jsx(Menu, __assign({ anchorEl: anchorEl, open: open, onClose: handleClose, onClick: handleClose }, MenuProps, { children: _jsx(HorizontalSubMenuContext.Provider, { value: value, children: children }) }))] }));
};
var PREFIX = 'RaHorizontalSubMenu';
var SubMenuClasses = {
    open: "".concat(PREFIX, "-open"),
    notOpen: "".concat(PREFIX, "-not-open"),
    selected: "".concat(PREFIX, "-selected"),
};
var Root = styled('div')((_a = {},
    _a["& .".concat(SubMenuClasses.open)] = {
        fontWeight: 600,
    },
    _a["& .".concat(SubMenuClasses.open)] = {
        background: 'rgba(0,0,0,0.1)',
    },
    _a["& .".concat(SubMenuClasses.notOpen)] = {
        background: 'transparent',
    },
    _a.display = 'flex',
    _a.justifyContent = 'center',
    _a.alignItems = 'center',
    _a));
var StyledTab = styled(Tab)({
    opacity: 1,
    minHeight: '24px',
});
